import React from 'react';
import { DateTime } from 'luxon';
import { TickProps } from '../../Charts/types';
import { themeColors } from '../../Charts/common';

export function MonthTick({
  payload, x, y,
}: TickProps<string>) {
  const date = DateTime.fromFormat(payload.value, 'yyyy-MM-dd');
  const monthName = date.setLocale('es').toFormat('MMM');
  const { year, month, day } = date;
  const isJanuary = month === 1;
  const isDisplayableMonth = (month - 1) % 2 === 0 && day === 1;
  if (isDisplayableMonth) {
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          className="text-capitalize fs-2xs"
          dx={-10}
          textAnchor="middle"
          fill={themeColors.subtitle}
          transform="rotate(-90)"
        >
          {monthName}
        </text>
        {isJanuary && (
        <text
          x={2}
          y={20}
          dy={20}
          className="fs-2xs fw-bold"
          textAnchor="middle"
          fill={themeColors.gray[500]}
        >
          {year}
        </text>
        )}
      </g>
    );
  }

  return null;
}
